import { Contact, RecipientContact } from '../model/Contact'

export const ERROR_MESSAGE =
  'Il est impossible d’ajouter ce contact car aucune adresse physique ou électronique n’a été renseignée.'

export const mapContactToRecipientContact = (contact: Contact): RecipientContact | never => {
  if (!contact.organizations.length && !contact.mssEmails.length) {
    throw new Error(ERROR_MESSAGE)
  }

  return {
    ...contact,
    mainRecipient: false,
    copyRecipient: false,
    assignedDoctor: false,
    addressingDoctor: false,
    organization: contact.organizations[0] || null,
    mssEmail: contact?.mssEmails?.[0] || null,
  }
}
